import { atom } from "recoil";

export const openAssetsParentToChildAtom = atom<boolean>({
  key: "openAssetsParentToChildAtom",
  default: true,
});

export const selectionModelAtom = atom<string[]>({
  key: "selectionModelAtom",
  default: [],
});
